<!-- Built with Common Launchpad 4.0.2 -->

<template>
  <div class="filter-group" v-if="filter.hideFilter === 'False' || filter.hideFilter === undefined">
    <control-checkbox v-if="filter.groupType === 'checkbox'"
                      :controls="filter.subgroup"
                      :class="filter.className"
                      :parent="filter"
                      :specification="filter.specification"
                      @updatecheckboxfilter="updateCheckboxFilter"/>
<!--    <control-radio v-if="filter.groupType === 'radio'"-->
<!--                   :controls="filter.subgroup"-->
<!--                   :parent="filter" v-bind-->
<!--                   :specification="filter.specification"/>-->
    <control-select v-if="filter.groupType === 'select'"
                    :control="filter.subgroup"
                    :defaultValue="filter.defaultValue"
                    :specification="filter.specification"/>
    <control-textbox v-if="filter.groupType === 'textbox'"
                     :control="filter.subgroup"
                     :parent="filter"
                     :className="filter.className"
                      @updateQueryValue="updateQueryValue"/>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';

import ControlCheckbox from './control-checkbox.vue';
import ControlSelect from './control-select.vue';
import ControlTextbox from "./control-textbox.vue"
import windowWidthMixin from '../../mixins/window-width';
// import ControlRadio from './control-radio.vue';

export default {
  props: ['filter', 'index'],
  mixins: [windowWidthMixin],
  data() {
    return {
      selectedValues: []
    };
  },
  components: {
    ControlCheckbox,
    ControlSelect,
    ControlTextbox,
    // ControlRadio
  },
  methods: {
    ...mapMutations('listing', { updateSpecification: 'updateSpecification' }),
    updateQueryValue(val) {
      this.$emit('updateQueryValue', val);
    },
    updateCheckboxFilter(val) {
      this.selectedValues = val;

      for (var i = 0; i < this.filter.subgroup.length; i++) {
        if (this.filter.subgroup[i].subgroup !== undefined && this.filter.subgroup[i].subgroup.length > 0) {
          this.getCheckboxFilters(this.filter.subgroup[i].subgroup, this.$refs['collapse-' + this.filter.specification].$children[0].$refs['collapse-' + i][0]);
        }
      }

      this.updateSpecification({
        key: this.filter.specification,
        value: encodeURIComponent(this.selectedValues),
        manualSearch: this.isSmallScreen
      });

      this.$emit('setSelectedValues', this.selectedValues);
    },
    getCheckboxFilters(group, parentRef) {
      let values = parentRef.$children[0].selectedValues;
      this.selectedValues = [...this.selectedValues, ...values];

      for (var i = 0; i < group.length; i++) {
        if (group[i].subgroup !== undefined && group[i].subgroup.length > 0) {
          this.getCheckboxFilters(group[i].subgroup, parentRef.$children[0].$refs['collapse-' + i][0]);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>